<template>
    <div>
        <div class="navbar-light bg-light title-navbar">
            <nav class="navbar navbar-expand-lg navbar-light bg-light container-navbar" >
                <!-- <button v-if="btnBack" type="button" class="btn btn-light btn-back" @click="$router.go(-1)">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </button> -->
                <button v-if="title!=''" type="button" class="btn btn-light btn-back" @click="$router.go(-1)">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
                <!-- <router-link v-if="title==''" class="navbar-brand" href="javascript:void(0)" :to="'manageform'" >
                    <img src="@/assets/logo.png" class="m-0 text-center" width="40px" alt="" srcset="">
                </router-link> -->
                <!-- <a class="navbar-brand" href="javascript:void(0)">
                    <img src="@/assets/logo.png" class="m-0 text-center" width="40px" alt="" srcset="">
                </a> -->
                <h2 v-if="title==''" class="m-0">
                    <img src="@/assets/logo.png" class="m-0 text-center" width="40px" alt="" srcset="">
                    Survey System
                </h2>
                <h2 v-else class="m-0 pl-3">{{ title }}</h2>

                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse pl-4" id="navbarNavDropdown">
                    <ul v-if="title==''" class="navbar-nav mr-auto">
                        <li v-for="(item,index) in listMenu" :key="index" :class="'nav-item'+(item.active ? ' active':'')">
                            <!-- <router-link class="nav-link" href="javascript:void(0)" :to="'manageform'"><h4><i class="text-black-50 fa fa-cogs" aria-hidden="true"></i> จัดการฟอร์ม</h4></router-link> -->
                            <router-link class="nav-link" href="javascript:void(0)" :to="item.to">
                                <h4><i :class="'fa fa-'+item.icon" aria-hidden="true"></i> {{ item.name }}</h4>
                            </router-link>
                        </li>
                    </ul>
                    <ul v-else class="navbar-nav mr-auto"></ul>
                    <form class="form-inline my-2 my-lg-0">
                        <img src="@/assets/user.png" class="m-0 text-center" width="40px" alt="" srcset="">
                        <span><i class="text-primary">{{ user.userId }}</i> | <b>{{ user.name }} {{ user.lastName }}</b></span>
                        <button type="button" class="btn btn-danger ml-4" title="ออกจากระบบ" @click="validatedLogout">ออกจากระบบ</button>
                    </form>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import store from '@/store';
import Api from './../api';

export default {

    components:{
    
    },

    props: {
        btnBack: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        // listMenu: {
        //     type: Array,
        //     default: () => []
        // },
    },

    data() {
        return {
            user: null,
            menuSubTitle: '',
            menuActiveSub:false,
            currentTitle: '',
            listMenu: [
                {
                    name: 'จัดการฟอร์ม',
                    icon: "file-text-o",
                    to: "manageform",
                    role: ['admin','super']
                },
                {
                    name: 'จัดการ FB Pixel',
                    icon: "facebook-square",
                    to: "managefacebookpixel",
                    role: ['admin','super']
                },
                {
                    name: 'จัดการ Line channel',
                    icon: "server",
                    to: "managelinechannel",
                    role: ['admin','super']
                },
                {
                    name: 'จัดการผู้ใช้งาน',
                    icon: "users",
                    to: "manageuser",
                    role: ['admin']
                },
                {
                    name: 'จัดการหน้าขอบคุณ',
                    icon: "picture-o",
                    to: "managethanks",
                    role: ['admin','super']
                }
            ]
        }
    },

    created(){
        this.user = this.$store.state.user;
        this.initActive();
        this.setRoleMenu();
    },

    mounted() {
        this.setCurrentActive()
    },

    watch: { 
        $route(to, from) {
            this.initActive();
            this.setCurrentActive();
        },
    },

    methods: {
        setRoleMenu(){
            var user = this.$store.state.user;
            this.listMenu = this.listMenu.filter(itM => {
                var role = itM.role.find(itP => itP==user.roleId)
                if(role!=undefined){
                    return itM;
                }
            })

            // this.$router.push({name:'keydataadmin'});
        },

        initActive() {
            this.listMenu.forEach((objM,idM) => {
                Vue.set(objM, 'active', false);
                if(objM.submenu){
                    objM.submenu.forEach((objS,idS) => {
                        Vue.set(objS, 'active', false);
                    });
                }
            })
        },

        setCurrentActive(){
            var path = this.$router.history.current.name;
            var menuCurrent = this.listMenu.filter(obj => obj.to == path)[0];
            if (menuCurrent) {
                menuCurrent.active = true;
            }
            this.showCollapseSubmenu();
        },

        showCollapseSubmenu(){
            var path = this.$router.history.current.name;
            this.listMenu.forEach((obj,index) => {
                if(obj.submenu) {
                    if(obj.submenu) {
                        var indexCurrent = obj.submenu.map(item => item.to).indexOf(path);
                        if(indexCurrent != -1) {
                            this.listMenu[index].active = true;
                            // this.listMenu[index].subMenuActive = true;
                            this.listMenu[index].submenu[indexCurrent].active = true
                            // console.log(this.listMenu[index])
                        }
                    }
                }
            });
        },

        validatedLogout(){
            this.$swal.fire({
                title: 'ต้องการออกจากระบบ?',
                text: "ตรวจสอบข้อมูลให้แน่ใจก่อนยืนยัน",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ยืนยัน',
                cancelButtonText: 'ยกเลิก'
                }).then((result) => {
                if (result.value) {
                    this.logout()
                }
            })
        },

        logout(token){
            var token = this.user.token;
            Api.logout(token).then(res => {
                var {data} = res;
                if (data.result) {
                    localStorage.setItem('user', JSON.stringify(null));
                    store.commit('set_user', null);
                    this.$router.push({ name:'login' })
                }
            }).catch(err => {
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
                this.isLogin = false;
            })
        }

    }
}
</script>

<style scoped>

    .navbar-light {
        background-color: #fff !important;
    }

    .logo {
        cursor: pointer;
    }

    .title-navbar{
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 999; 
    }

    .container-navbar{
        /* width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto; */

    }

    .btn-back {
        border-radius: 50% !important;
    }

    @media (min-width: 1200px){
        .container-navbar {
            /* max-width: 1140px; */
        }
    }

    @media (min-width: 992px) {

    }

    @media (min-width: 768px) {

    }

    @media (min-width: 576px) {

    }
</style>